import { TableCell, TableRow } from "@mui/material";
import { FC } from "react";

import { IBookingPrepareConflict } from "@ryde/shared";

interface IRejectedBookingsUploadRowProps {
  conflictRow: IBookingPrepareConflict;
}

export const RejectedBookingsUploadRow: FC<IRejectedBookingsUploadRowProps> = ({
  conflictRow,
}) => {
  return (
    <TableRow>
      <TableCell>{conflictRow.index}</TableCell>
      <TableCell>{conflictRow.passengerCode}</TableCell>
      <TableCell>{conflictRow?.date}</TableCell>
    </TableRow>
  );
};
